import React, { useEffect, useState } from 'react'
import Classes from './Files.module.css'
import { Pagination, Stack } from '@mui/material';
import useScreenWidth from '../../../../../../../../Hooks/useScreenWidth';
import SkeletonLoading from '../../../../../../../GlobalComponents/SkeletonLoading/SkeletonLoading';
import TableRow from './TableRow';
import { useNavigate } from 'react-router-dom';

export default function Files() {
    const initialfiles = [
        {
            id: 1,
            name: "Client Information",
            type: "PDF",
            uploaded: "March 1, 2025",
        },
        {
            id: 2,
            name: "Client Information",
            type: "Word",
            uploaded: "March 1, 2025",
        },
        {
            id: 3,
            name: "Project Plan",
            type: "Excel",
            uploaded: "March 2, 2025",
        },
        {
            id: 4,
            name: "Proposal Document",
            type: "PDF",
            uploaded: "March 3, 2025",
        },
        {
            id: 5,
            name: "Budget Report",
            type: "CSV",
            uploaded: "March 4, 2025",
        }
    ];

    const [loading, setLoading] = useState(true);
    const navigateTo = useNavigate();
    const screenWidth = useScreenWidth();
    const isMobile = screenWidth <= 480;

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

    const totalPages = Math.ceil(initialfiles.length / itemsPerPage);
    const currentItems = initialfiles.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );
    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, initialfiles.length);
    const totalItems = initialfiles.length;

    function handlePageChange(e, pageNum) {
        setCurrentPage(pageNum);
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div>
            <div className={Classes.tableHeader}>
                <div className={`${Classes.headerItem} ${Classes.headerCustomer}`}>
                    <input type='checkbox' />
                </div>
                <div className={`${Classes.headerItem} ${Classes.headerSpendings}`}>
                    <h5>Name</h5>
                </div>
                <div className={`${Classes.headerItem} ${Classes.headerBookings}`}>
                    <h5>Type</h5>
                </div>
                <div className={`${Classes.headerItem} ${Classes.headerDate}`}>
                    <h5>Uploaded</h5>
                </div>
                <div className={`${Classes.headerItem} ${Classes.headerDisable}`}>
                </div>
            </div>

            <div className={Classes.tableBody}>
                {loading ? (
                    <SkeletonLoading
                        length={itemsPerPage}
                        height={isMobile ? '6rem' : '2.8rem'}
                        width="100%"
                        br="6px"
                    />
                ) : currentItems && currentItems.length > 0 ? (
                    currentItems.map((cust, idx) => (
                        <TableRow
                            key={cust._id}
                            value={cust}
                            index={idx}
                        />
                    ))
                ) : (
                    <div>No data found.</div>
                )}
            </div>

            <div className={Classes.pagFooter}>
                <h5 style={{ height: '1.2rem' }}>
                    {loading
                        ? <SkeletonLoading height='1.2rem' width='10rem' br='4px' padding='0' />
                        : `Showing ${startItem} to ${endItem} of ${totalItems} results`
                    }
                </h5>
                <Stack spacing={2} className={Classes.pagination}>
                    {loading
                        ? <SkeletonLoading height='1.2rem' width='5rem' br='4px' padding='0' />
                        : <Pagination
                            count={totalPages}
                            page={currentPage}
                            onChange={handlePageChange}
                            shape="rounded"
                        />
                    }
                </Stack>
            </div>
        </div>
    )
}
